import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent/DataTableLoading'
import { WorkspacesBreadcrumbs } from '../WorspacesBreadcrumbs'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { Suspense } from 'react'
import { useRestClient } from '@/contexts/QueryProvider'
import { DataTable } from '@/components/ui/DataTable/DataTable'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { useCurrentWorkspace } from '../useCurrentWorkspace'
import { workspaceEntitiesColumns } from './WorkspaceEntitiesTable/workspaceEntitiesColumns'

export const WorkspaceEntitiesPage = () => {
  return (
    <>
      <WorkspacesBreadcrumbs title="Entities" />
      <QueryErrorBoundary errorMessage="Failed to fetch roles">
        <Suspense fallback={<DataTableLoading />}>
          <WorkspaceEntitiesPanelContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function WorkspaceEntitiesPanelContent() {
  const { getWorkspacesApiGetOrganisationWorkspaceEntities } = useRestClient()
  const { workspaceId } = useCurrentWorkspace()
  const { data: entities } = getWorkspacesApiGetOrganisationWorkspaceEntities.useSuspenseQuery({
    query: { workspaceId },
  })

  return (
    <TablePageContainer>
      <DataTable columns={workspaceEntitiesColumns} data={entities} />
    </TablePageContainer>
  )
}
